import { Address, createEmptyAddress } from '@/models/address';
import { SeoMetaData } from '@/models/seoMetaData';

export type Facility = {
    id: string;
    name: string;
    address: Address;
    metaData: SeoMetaData[];
};

export type CreateFacility = {
    name: string;
    address: Address;
    metaData: SeoMetaData[];
};

export const createEmptyCreateFacility = (): CreateFacility => {
    return {
        name: '',
        address: createEmptyAddress(),
        metaData: [],
    };
};
